// Single entry point for Matomo tracking
export default class Tracking {

    // Store the last tracked path, so we can log where the user came from
    static _lastTrackedPath = ''

    // Custom action dimensions used in Matomo
    static DIMENSIONS = {
        TYPE_OF_USER: '6',
        USER_ID: '7',
        MARKET_ID: '8',
        IS_DEMO: '9',
        SUBDOMAIN: '10',
    }

    // Example path: groups/show
    static currentPath() {
        return (window.app?.controller?.activePath ?? []).join('/')
    }

    static initialize() {
        // Only use Matomo in production mode
        if (PRODUCTION) {
            if (DOMAIN.isLive) {
                window.statsTracker = window.Matomo.getTracker('https://stats.learnbeat.nl/matomo.php', '1');
            } else {
                window.statsTracker = window.Matomo.getTracker('https://stats.learnbeat.nl/matomo.php', '3');
            }
            window.statsTracker.enableLinkTracking(true);
        } else {
            window.statsTracker = {
                setCustomUrl() { },
                trackPageView() { },
                trackEvent() {
                    // console.log('Tracking event', arguments);
                },
                setUserId() { },
                setCustomDimension() { }
            };
        }
    }

    static trackNavigation() {

        const currentPath = this.currentPath()

        // Use the URL without id's to track a page view
        window.statsTracker.setCustomUrl(`${window.location.origin}/${currentPath}`)
        window.statsTracker.trackPageView()

        // Track a navigation event with from and to path
        if (this._lastTrackedPath) {
            this.trackEvent(this._lastTrackedPath, `Navigate to: ${currentPath}`)
        }
        this._lastTrackedPath = currentPath
    }

    static trackEvent(category, action, name, value) {
        window.statsTracker.trackEvent(category, action, name, value)
    }

    static trackFeatureEvent(action, name, value) {
        window.statsTracker.trackEvent(this.currentPath(), action, name, value)
    }

    static setUserId(id) {
        window.statsTracker.setUserId(id)
    }

    static setCustomDimension(id, value) {
        window.statsTracker.setCustomDimension(id, value)
    }
}
